export default "__VITE_ASSET__BURIJYYj__"